module.exports = __webpack_public_path__ + "static/media/camastros.7304ca35.png";